import { Popover as BasePopover } from "@base-ui/react/popover";

import type { MonthPickerBackdropProps } from "./MonthPicker.types";

export function MonthPickerBackdrop({ ...props }: MonthPickerBackdropProps) {
  return <BasePopover.Backdrop data-slot="month-picker-backdrop" {...props} />;
}
